import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import * as Urls from 'src/constants/EndpointUrls';
import { getItem } from 'src/reducers/common/itemReducer';
import { redirectTo, concatParamsToUrl } from 'src/utils/Http';
import { REDUCER_NAME } from 'src/reducers/desk/syncWithAttendance';

import ClientListShowTable from './Components/ClientListShowTable';
import SyncSettingForm from './Components/SyncSettingForm';
import RecheckSyncSettingForm from './Components/RecheckSyncSettingForm';

import ResponseMessage from './Components/ResponseMessage';

export const ClientListShow = ({ values, syncWithAttendance }) => {
  const [customFeatures, setCustomFeatures] = useState(values.customFeatures);
  const form = useRef(null);
  const lastSyncWithApiServer = values?.client?.lastSyncWithApiServer || false;

  const handleSearch = (event, reset = false) => {
    if (event) event.preventDefault();
    if (!form.current) return;
    const { featureName } = form.current;
    const searchValue = !reset ? featureName.value : '';

    const filteredFeatures = values.customFeatures.filter(feature => {
      const nameEn = feature.nameEn?.toLocaleLowerCase() || '';
      const nameTh = feature.nameTh?.toLocaleLowerCase() || '';
      const nameJp = feature.nameJp?.toLocaleLowerCase() || '';
      return nameEn.includes(searchValue) || nameTh.includes(searchValue) || nameJp.includes(searchValue);
    });
    setCustomFeatures(filteredFeatures);

    if (reset) form.current.reset();
  };

  const redirectToNewPage = () => {
    const url = concatParamsToUrl(Urls.CLIENT_CUSTOM_FEATURE_NEW, { client_id: values.client.id });
    redirectTo(url);
  };

  return (
    <div className="l-wrap-xl">
      <div className="d-flex justify-content-between align-items-center">
        <h1>{values.client.name}</h1>
        <div className="d-flex">
          <form ref={form} onSubmit={handleSearch}>
            <div className="input-group">
              <input type="text" className="form-control" placeholder="Features name" name="featureName" />
              <div className="input-group-append" id="button-addon4">
                <button className="btn btn-primary">Search</button>
                <button className="btn btn-outline-secondary" type="button" onClick={() => handleSearch(null, true)}>
                  Clear
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <ResponseMessage />

      <div style={{ display: 'inline-grid', width: '100%' }}>
        {lastSyncWithApiServer || syncWithAttendance?.synced ? (
          <RecheckSyncSettingForm client={values.client} />
        ) : (
          <SyncSettingForm client={values.client} />
        )}
      </div>

      <div className="d-flex justify-content-end" style={{ marginBottom: '1rem' }}>
        <button className="btn btn-primary" onClick={redirectToNewPage}>
          New
        </button>
      </div>

      <ClientListShowTable client={values.client} customFeatures={customFeatures} />
    </div>
  );
};

const mapStateToProps = state => ({
  syncWithAttendance: getItem(REDUCER_NAME, state)
});

export default connect(mapStateToProps)(ClientListShow);
